import cn from 'classnames'
import { trackMarketingAction } from 'components/JumpNav/events'
import { useActiveAnchor } from 'components/JumpNav/useActiveAnchor'
import Link from 'components/Link'
import { ScrollAnimation } from './ScrollAnimation'
import styles from './JumpNav.module.scss'

interface JumpNavProps {
  slug: string
  items: { copy: string; anchor: string }[]
}

// Based on JumpNav component in web/apps/next/src/components/JumpNav/JumpNav.tsx but with a custom styles
export const JumpNav = ({ slug, items }: JumpNavProps) => {
  const { activeAnchor } = useActiveAnchor(items.map((i) => i.anchor))

  const renderItems = () =>
    items.map(({ copy, anchor }) => (
      <div className='col' key={anchor}>
        <Link
          className={cn(
            styles.Item,
            {
              [styles.ItemActive]: anchor === activeAnchor,
            },
            'd-flex justify-content-center align-items-center mc-py-3',
          )}
          href={`#${anchor}`}
          onClick={trackMarketingAction(copy, slug)}
          isBasic
        >
          {copy}
        </Link>
      </div>
    ))

  return (
    <nav className={`${styles.JumpNav} uncontainer`}>
      <ScrollAnimation duration={0.2}>
        <div className='row justify-content-center no-gutters'>
          <div className='col-12 col-md-8 col-lg-6'>
            <div className='row no-gutters justify-content-center mc-h-100'>
              {renderItems()}
            </div>
          </div>
        </div>
      </ScrollAnimation>
    </nav>
  )
}
